import { useState } from 'preact/hooks';
import { ApiError, trocarSenha } from '../api';
import { CampoSenha } from './Campos';
import { BotaoInstalar } from './Instalar';
import { BotaoTema } from './Tema';
import { fazerLogin, fazerLogout, senhaTrocada } from '../session';

export function Login() {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: Event) {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await fazerLogin(email.trim(), senha);
    } catch (err) {
      setErro(
        err instanceof ApiError && err.status === 429
          ? 'Muitas tentativas. Aguarde um minuto e tente de novo.'
          : err instanceof ApiError && err.status === 401
            ? 'E-mail ou senha inválidos.'
            : 'Não foi possível entrar agora. Tente novamente.',
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <main class="auth">
      <div class="auth-canto">
        <BotaoInstalar class="botao compacto" />
        <BotaoTema />
      </div>
      <form class="auth-cartao" onSubmit={enviar}>
        <h1>MAPAS</h1>
        <p class="auth-sub">Acompanhamento das ações do governo · Paraíba</p>

        <label for="email">E-mail</label>
        <input id="email" type="email" autocomplete="username" required value={email} onInput={(e) => setEmail(e.currentTarget.value)} autofocus />

        <label for="senha">Senha</label>
        <CampoSenha id="senha" autocomplete="current-password" required value={senha} onInput={setSenha} />

        {erro && (
          <p class="erro" role="alert">
            {erro}
          </p>
        )}
        <button type="submit" class="primario" disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
        <p class="auth-nota">Acesso restrito a usuários cadastrados pelo gestor.</p>
      </form>
    </main>
  );
}

/** Tela obrigatória no primeiro acesso (senha temporária) — a pessoa não vê o painel antes de trocá-la. */
export function TrocarSenhaObrigatoria() {
  const [atual, setAtual] = useState('');
  const [nova, setNova] = useState('');
  const [confirma, setConfirma] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: Event) {
    e.preventDefault();
    setErro('');
    if (nova.length < 10) return setErro('A nova senha precisa ter ao menos 10 caracteres.');
    if (nova !== confirma) return setErro('A confirmação não é igual à nova senha.');
    setEnviando(true);
    try {
      await trocarSenha(atual, nova);
      senhaTrocada();
    } catch (err) {
      setErro(err instanceof ApiError ? err.details?.[0]?.mensagem ?? err.message : 'Não foi possível trocar a senha.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <main class="auth">
      <div class="auth-canto">
        <BotaoInstalar class="botao compacto" />
        <BotaoTema />
      </div>
      <form class="auth-cartao" onSubmit={enviar}>
        <h1>Defina sua senha</h1>
        <p class="auth-sub">Este é o seu primeiro acesso. Troque a senha temporária por uma só sua.</p>

        <label for="atual">Senha temporária</label>
        <CampoSenha id="atual" autocomplete="current-password" required value={atual} onInput={setAtual} autofocus />

        <label for="nova">Nova senha (mínimo 10 caracteres)</label>
        <CampoSenha id="nova" autocomplete="new-password" required minLength={10} value={nova} onInput={setNova} />

        <label for="confirma">Repita a nova senha</label>
        <CampoSenha id="confirma" autocomplete="new-password" required value={confirma} onInput={setConfirma} />

        {erro && (
          <p class="erro" role="alert">
            {erro}
          </p>
        )}
        <button type="submit" class="primario" disabled={enviando}>
          {enviando ? 'Salvando…' : 'Salvar e continuar'}
        </button>
        <button type="button" class="link" onClick={() => void fazerLogout()}>
          Sair
        </button>
      </form>
    </main>
  );
}
